export default __webpack_public_path__ + "static/middleby-logo-1484c65ba55a2ce84ffb1180887e88cd.png";